(function(AddToCart, $, undefined) {
  
  var bindUIActions = function() {
    $('[data-disabled]').on('click', function() {
      if ($(this).is('[data-disabled]')) {
        $('[data-select-cta]').addClass('select-cta--open select-cta__side--warn');
      }
    });
    
    $('[data-variant-select-item]').on('click', function(e) {
      var variantQty = $(this).attr('data-variant-quantity');
      var variantId = $(this).attr('data-variant-id');
      var variantPrice = $(this).attr('data-variant-price');
      var variantTitle = $(this).attr('data-variant-title');
      var productId = $(this).attr('data-product-id');
      var productTitle = $(this).attr('data-product-title');
      var isToggle = $(this).attr('data-is-toggle');
      var isOpen = $(this).closest('[data-select-cta]').hasClass('select-cta--open');
      var isShop = $(this).attr('data-is-shop');
      var productType = $(this).attr('data-product-type');
      var productHandle = $(this).attr('data-variant-select-item');
      var outOfStock = $(this).attr('data-variant-out-of-stock');

      if (isOpen) {
        $('.select-cta__btn').removeClass('select-cta__btn--selected');
        $(this).addClass('select-cta__btn--selected');
      }
      $(this).closest('[data-select-cta]').toggleClass('select-cta--open');
      
      if (isShop) {
        $(this).closest('[data-product-tile]').find('[data-product-type]').hide();
        $(this).closest('[data-product-tile]').find('[data-product-type=' + productType + ']').show();
      } else {
        if (isToggle) {
          $('[data-variant-add-to-cart]').attr('data-disabled', true);
        } else {
          $('[data-variant-add-to-cart]').removeAttr('data-disabled');
          $('[data-select-cta]').removeClass('select-cta__side--warn');
          if (outOfStock === 'true') {
            $('[data-variant-add-to-cart]').hide();
            $('[data-backordered]').attr('data-remodal-target', productHandle).show();
          } else {
            $('[data-backordered]').hide();
            $('[data-variant-add-to-cart]').show().attr({
              'disabled': false,
              'data-variant-quantity': variantQty,
              'data-variant-id': variantId,
              'data-variant-price': variantPrice,
              'data-variant-title': variantTitle,
              'data-product-id': productId,
              'data-product-title': productTitle
            })
          }
        }
      }
    });
  }

  AddToCart.init = function() {
    bindUIActions();
  }

}(window.AddToCart = window.AddToCart || {}, jQuery));